/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Stack,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import style from "../../../styles/common/formModal.module.css";
import countries from "../../../../src/Pages/Masters/Roles and Permissions/Country.json";
import EditDialog from "../../../Components/Common/EditDialog";
import FileField from "../../../Components/Masters/FileField";
import formatTitleWithOptional from "../../Scope1/OptionalFeild";
import GoogleMapsAutocomplete from "../../../Components/Common/GoogleMapsAutocomplete";
import ShipAutocomplete from "../../../Components/Common/ShipAutocomplete";
import AirportAutocomplete from "../../../Components/Common/AirportAutocomplete";
import GoogleMapsAutocompleteRail from "../../../Components/Common/GoogleMapsAutocompleteRail";
import { parseAddressComponents } from "../../../utils/common";
import { useUser } from "../../../context/AuthContext";
import Multiline from "../../../Components/Masters/Multiline";

const Form = ({
  isOpen,
  onClose,
  onSubmit,
  header,
  initialData,
  isEditing,
  defaultValue,
  id,
}) => {
  const { user } = useUser();

  const initialFormData = {
    dateOfTravel: initialData?.dateOfTravel || "",
    daysOfHotelStay: initialData?.daysOfHotelStay ?? "",
    employeeName: initialData?.employeeName || "",
    travelType: initialData?.travelType || "",
    employeePosition: initialData?.employeePosition || "",
    travelMode: initialData?.travelMode || "",
    travelLocations: initialData?.travelLocations || [],
    origin: initialData?.origin || "",
    destination: initialData?.destination || "",
    travelDuration: {
      value: initialData?.travelDuration?.value || 0,
      unit: initialData?.travelDuration?.unit || "Days",
    },
    airDetailsClass: initialData?.airDetailsClass || "",
    roadDetailsVehicle: initialData?.roadDetailsVehicle || "",
    railDetails: {
      vehicleType: initialData?.railDetails?.vehicleType || "",
    },
    waterDetails: {
      vehicleType: initialData?.waterDetails?.vehicleType || "",
    },
    country: initialData?.country || "",
    numberOfNights: initialData?.numberOfNights || 1,
    accommodation: initialData?.accommodation || "",
    roomType: initialData?.roomType || "",
    hotelRating: initialData?.hotelRating || 1,
    unitOfTravel: initialData?.unitOfTravel || "Days",
    unitOfStay: initialData?.unitOfStay || "Days",
    documents: initialData?.documents || [],
    distanceCovered: initialData?.distanceCovered || "",
    editRemarkReason: initialData?.editRemarkReason || "",
  };
  const [editDialog, setEditDialog] = useState(false);
  const intialCoordinates = {
    originCoordinates: {
      lat: 0,
      lng: 0,
    },
    destinationCoordinates: {
      lat: 0,
      lng: 0,
    },
    layoverCoordinates: [],
  };
  const [coordinates, setCoordinates] = useState(intialCoordinates);
  const fieldConfig = [
    {
      label: "Date of Travel",
      name: "dateOfTravel",
      type: "date",
      required: true,
      // placeholder:"Enter date of travel"
    },
    {
      label: "Employee Name",
      name: "employeeName",
      type: "text",
      placeholder: "Enter Employee Name",
      required: true,
    },
    {
      label: "Employee Position",
      name: "employeePosition",
      type: "text",
      placeholder: "Enter Employee Position",
      required: true,
    },
    {
      label: "Travel Type",
      name: "travelType",
      type: "select",
      options: ["Domestic Travel", "International Travel"],
      required: true,
    },
    {
      label: "Mode of Business travel",
      name: "travelMode",
      type: "select",
      options: ["Air", "Road", "Rail", "Water"],
      required: true,
    },
    {
      label: "Air Travel Class",
      name: "airDetailsClass",
      type: "dynamic",
      options: [
        "Economy Class",
        "Premium Economy Class",
        "Business Class",
        "First Class",
      ],
    },
    {
      label: "Vehicle Type",
      name: "roadDetailsVehicle",
      type: "dynamic",
      options: ["Taxi", "Bus"],
      required: false,
    },
    {
      label: "Origin Location",
      name: "origin",
      type: "location",
      placeholder: "Enter Origin",
      required: true,
    },
    {
      label: "Destination Location",
      name: "destination",
      type: "location",
      placeholder: "Enter Destination",
      required: true,
    },
    {
      label: "Layover Locations (optional)",
      name: "travelLocations",
      type: "multiple",
      placeholder: "Enter Travel Locations (comma-separated)",
    },

    // {
    //   label: "Distance Covered",
    //   name: "distanceCovered",
    //   type: "distance",
    //   placeholder: "Enter Number",
    // },
    {
      label: "Distance Covered (Km)",
      name: "distanceCovered",
      type: "dynamic",
      options: [
        "Economy Class",
        "Premium Economy Class",
        "Business Class",
        "First Class",
      ],
    },

    {
      label: "Country",
      name: "country",
      type: "select",
      placeholder: "Enter Country",
      required: true,
      options: countries?.countries?.map((country) => country.name),
    },
    {
      label: "No. of Nights Stay in Hotel",
      name: "daysOfHotelStay",
      type: "number",
      placeholder: "Enter Number",
      required: true,
      options: countries?.countries?.map((country) => country.name),
    },
    {
      // label: "Edit Remark Reason",
      name: "editRemarkReason",
      type: "multlyline",
      placeholder: "Additional edit remarks",
      require: true,
    },
    {
      // label: "Upload Documents",
      name: "document",
      type: "docs",
      placeholder: "Enter Document",
    },
  ];

  const initialErrors = {};

  const [formData, setFormData] = useState(initialFormData);
  const [formData2, setFormData2] = useState(initialFormData);
  const [newLocation, setNewLocation] = useState("");
  const [errors, setErrors] = useState(initialErrors);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const travelMode = formData?.travelMode || "Road";

  useEffect(() => {
    // if (isOpen && isEditing) {
    // setFormData(initialData);
    // setFormData2(initialData);
    setUploadedFiles(initialData?.documents || []);

    // setCoordinates(initialData?.coordinates);
    // } else {
    setFormData(initialFormData);
    setFormData2(initialFormData);
    // }
  }, [id, initialData]);

  useEffect(() => {
    if (isEditing && initialData?.coordinates) {
      setCoordinates(initialData.coordinates);
    } else {
      setCoordinates(intialCoordinates);
    }
  }, [isOpen, isEditing, initialData?.coordinates]);

  const handleExitAgree = () => {
    setEditDialog(false);
    // setAddData(false);
    setErrors({});
    setNewLocation("");
    setFormData(initialFormData);
    setFormData2(initialFormData);
    onClose();
  };
  const validateFormData = () => {
    const newErrors = {};
    fieldConfig.forEach((field) => {
      if (!field.required) {
        return;
      }

      const value = field.name.includes(".")
        ? formData[field.name.split(".")[0]]?.[field.name.split(".")[1]]
        : formData[field.name];
      // Required field validation (0 is valid for number fields)
      const isMissingRequired =
        field.type === "number"
          ? value === "" || value == null
          : !value && field.type !== "multiple" && field.type !== "docs";
      if (isMissingRequired) {
        newErrors[field.name] = `${field.label} is required.`;
      }

      // Specific type validations
      if (field.type === "number" && value && value < 0) {
        newErrors[field.name] = `${field.label} must be a positive number.`;
      }

      if (field.type === "date" && value && isNaN(new Date(value).getTime())) {
        newErrors[field.name] = `${field.label} is an invalid date.`;
      }
      if (formData?.editRemarkReason === "") {
        if (user?.endUser && isEditing) {
          newErrors.editRemarkReason = "Edit remark is required";
        }
      }
      // Custom validation for travel locations
      // if (
      //   field.type === "multiple" &&
      //   (!formData[field.name] || formData[field.name].length === 0)
      // ) {
      //   newErrors[
      //     field.name
      //   ] = `${field.label} must have at least one location.`;
      // }
      if (formData.travelMode === "Water") {
        const distance = Number(formData.distanceCovered);
        if (!distance || isNaN(distance) || distance <= 0) {
          newErrors.distanceCovered =
            "Please enter a valid distance greater than 0";
        }
      }

      // Custom validation for documents if required
      if (field.type === "docs" && formData[field.name]?.length === 0) {
        newErrors[
          field.name
        ] = `Please upload at least one document for ${field.label}.`;
      }
    });
    setErrors(newErrors);
    // Return true if there are no errors
    return Object.values(newErrors).every((error) => error === "");
  };
  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];
      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    if (isFormDataUnchanged) {
      handleExitAgree();
      setUploadedFiles([]);
      setCoordinates(intialCoordinates);
      setFormData(initialFormData);
    } else {
      setUploadedFiles([]);
      setCoordinates(intialCoordinates);
      setFormData(initialFormData);
      setEditDialog(true);
      // onClose();
    }
  };

  const handleSubmit = () => {
    if (!validateFormData()) return;

    let formDataToSubmit = {
      ...formData,
      documents: uploadedFiles,
      coordinates: {
        originCoordinates: coordinates.originCoordinates,
        destinationCoordinates: coordinates.destinationCoordinates,
        layoverCoordinates: coordinates.layoverCoordinates || [],
      },
    };
    if (user?.endUser && isEditing) {
      formDataToSubmit.requestStatus = "edit";
      formDataToSubmit.requestMode = true;
      formDataToSubmit.approvalStatus = "Pending";
    }
    onSubmit(formDataToSubmit, isEditing);
    setUploadedFiles([]);
    setCoordinates(intialCoordinates);
    // onClose();
  };

  const handleChange = (field, type) => (event) => {
    const { value } = event.target;
    if (field === "travelMode") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        origin: "",
        destination: "",
        travelLocations: [],
        distanceCovered: "",
        airDetailsClass: "",
        roadDetailsVehicle: "",
        railDetails: { vehicleType: "" },
        waterDetails: { vehicleType: "" },
      }));

      // Also reset the coordinates
      setCoordinates(intialCoordinates);
    } else {
      if (type === "number" && value !== "" && !/^\d+$/.test(value)) return;
      if (type === "text" && value !== "" && /^\d+$/.test(value)) return;
      setFormData((prev) => {
        const fieldParts = field.split(".");
        if (fieldParts.length === 1) {
          return {
            ...prev,
            [field]: value,
          };
        } else {
          return {
            ...prev,
            [fieldParts[0]]: {
              ...prev[fieldParts[0]],
              [fieldParts[1]]: value,
            },
          };
        }
      });
    }

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };
  const handleAddLocation = () => {
    if (newLocation.trim() && !formData.travelLocations.includes(newLocation)) {
      setFormData((prevData) => ({
        ...prevData,
        travelLocations: [...prevData.travelLocations, newLocation.trim()],
      }));
      setNewLocation(null);
    }
  };

  const handleDeleteLocation = (locationToDelete, index) => {
    setFormData((prevData) => ({
      ...prevData,
      travelLocations: prevData.travelLocations.filter(
        (loc) => loc !== locationToDelete
      ),
    }));

    setCoordinates((prev) => ({
      ...prev,
      layoverCoordinates: prev.layoverCoordinates.filter((_, i) => i !== index),
    }));
  };

  const handleLocationChange = (fieldName, value) => {
    const addressDetails = parseAddressComponents(
      value?.name,
      value?.address_components
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: addressDetails,
    }));
    const newCoordinates = value
      ? { lat: value?.location?.lat, lng: value?.location?.lng }
      : null;

    if (newCoordinates) {
      setCoordinates((prev) => ({
        ...prev,
        [fieldName === "origin"
          ? "originCoordinates"
          : "destinationCoordinates"]: newCoordinates,
        layoverCoordinates: prev.layoverCoordinates || [],
      }));
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const handleLocationChangeWater = (fieldName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
  };

  const handleLayover = (fieldName, value, name) => {
    let locationValue = "";
    let newCoordinates = null;

    if (name === "road") {
      const addressDetails = parseAddressComponents(
        value?.name,
        value?.address_components
      );
      locationValue = addressDetails;
      newCoordinates = value
        ? { lat: value?.location?.lat, lng: value?.location?.lng }
        : null;
    } else if (name === "rail") {
      locationValue = value?.name;
      newCoordinates = value
        ? { lat: value?.location?.lat, lng: value?.location?.lng }
        : null;
    } else if (name === "air") {
      locationValue = value?.label;
      newCoordinates = value
        ? { lat: value.latitude, lng: value.longitude }
        : null;
    } else if (name === "water") {
      locationValue = value;
    }

    setNewLocation(locationValue);

    if (newCoordinates) {
      setCoordinates((prev) => ({
        ...prev,
        layoverCoordinates: [
          ...(prev.layoverCoordinates || []),
          newCoordinates,
        ],
        // Preserve origin and destination coordinates
        originCoordinates: prev.originCoordinates,
        destinationCoordinates: prev.destinationCoordinates,
      }));
    }
  };
  const handleLocationChangeAir = (fieldName, value) => {
    const newValue = value?.label || "";

    const newCoordinates = value
      ? { lat: value.latitude, lng: value.longitude }
      : null;

    setFormData((prevState) => {
      const updated = {
        ...prevState,
        [fieldName]: newValue,
      };
      return updated;
    });

    if (newCoordinates) {
      setCoordinates((prev) => ({
        ...prev,
        [fieldName === "origin"
          ? "originCoordinates"
          : "destinationCoordinates"]: newCoordinates,
        // Preserve all other coordinates
        layoverCoordinates: prev.layoverCoordinates || [],
      }));
    }
    // Set coordinates and fetch distance if both present
    // if (fieldName === "origin") {
    //   setOriginCoordinates(newCoordinates);
    // } else if (fieldName === "destination") {
    //   setDestinationCoordinates(newCoordinates);
    // }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: value ? "" : prevErrors[fieldName],
    }));
  };

  const handleLocationChangeRail = (fieldName, value) => {
    setFormData((prev) => {
      const newState = {
        ...prev,
        [fieldName]: value?.name || "",
      };

      return newState;
    });

    const newCoordinates = value
      ? { lat: value?.location?.lat, lng: value?.location?.lng }
      : null;

    if (newCoordinates) {
      setCoordinates((prev) => ({
        ...prev,
        [fieldName === "origin"
          ? "originCoordinates"
          : "destinationCoordinates"]: newCoordinates,
        // Preserve all other coordinates
        layoverCoordinates: prev.layoverCoordinates || [],
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [fieldName]: value ? "" : prev[fieldName],
    }));
  };
  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      // open={addData}
      open={isOpen}
      onClose={handleClose}
      // onClose={handleClose}>
    >
      <Box
        sx={{
          width: "26rem",
          display: "flex",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        {editDialog && (
          <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
        )}
        <Box
          sx={{
            backgroundColor: "#fff",
            height: "20px",
            padding: "13px",
            margin: "30px 0 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "80%",
            width: "5%",
            zIndex: "1",
          }}
        >
          <IconButton onClick={handleClose} sx={{ color: "black" }}>
            <CloseIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Box>
        <Box className={style.main_div}>
          <Typography
            id="modal-title"
            variant="h6"
            align="left"
            sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
          >
            {header}
          </Typography>
          <form>
            {fieldConfig.map((field) => {
              const shouldRender =
                (formData?.travelMode === "Air" &&
                  field.name === "airDetailsClass") ||
                (formData?.travelMode === "Road" &&
                  field.name === "roadDetailsVehicle") ||
                (formData?.travelMode === "Water" &&
                  field.name === "distanceCovered") ||
                field.type !== "dynamic";

              if (!shouldRender) return null;
              return (
                <div key={field.name} style={{ margin: "1rem 0" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    {formatTitleWithOptional(field.label)}
                  </Typography>

                  {user?.endUser && isEditing && field.type === "multlyline" ? (
                    <Multiline
                      title={formatTitleWithOptional("Edit Remark Reason")}
                      placeholder="Additional edit remarks"
                      fieldName="editRemarkReason"
                      value={formData.editRemarkReason}
                      handleChange={handleChange("editRemarkReason")}
                      errors={errors.editRemarkReason}
                    />
                  ) : null}

                  {field.type === "text" ||
                  field.type === "date" ||
                  field.type === "number" ? (
                    <TextField
                      type={field.type === "date" && "date"}
                      size="small"
                      fullWidth
                      placeholder={field.placeholder || ""}
                      value={
                        field.name.includes(".")
                          ? formData[field.name.split(".")[0]]?.[
                              field.name.split(".")[1]
                            ] ?? ""
                          : formData[field.name] ?? ""
                      }
                      onChange={handleChange(field?.name, field?.type)}
                      error={Boolean(errors[field.name])}
                      // helperText={errors[field.name] || ""}
                      helperText={
                        <Typography
                          variant="body2"
                          color="#D34040"
                          sx={{ marginLeft: "-0.8rem" }}
                        >
                          {errors[field.name] || ""}
                        </Typography>
                      }
                      inputProps={
                        field.type === "date"
                          ? { max: new Date().toISOString().split("T")[0] }
                          : {}
                      }
                    />
                  ) : field.type === "select" ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              maxWidth: "200px",
                              maxHeight: "200px",
                            },
                          },
                        },
                      }}
                      value={
                        field?.name?.includes(".")
                          ? formData[field?.name.split(".")[0]]?.[
                              field?.name.split(".")[1]
                            ] || ""
                          : formData[field?.name] || "Tap to select"
                      }
                      onChange={handleChange(field?.name)}
                      error={Boolean(errors[field.name])}
                      // helperText={errors[field.name] || ""}
                      helperText={
                        <Typography
                          variant="body2"
                          color="#D34040"
                          sx={{ marginLeft: "-0.8rem" }}
                        >
                          {errors[field.name] || ""}
                        </Typography>
                      }
                    >
                      <MenuItem value="Tap to select" disabled>
                        {defaultValue || "Tap to select"}
                      </MenuItem>
                      {field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : field.type === "distance" &&
                    formData?.travelMode === "Water" ? (
                    <TextField
                      type={"text"}
                      size="small"
                      fullWidth
                      placeholder={field.placeholder || ""}
                      value={
                        field.name.includes(".")
                          ? formData[field.name.split(".")[0]]?.[
                              field.name.split(".")[1]
                            ] ?? ""
                          : formData[field.name] ?? ""
                      }
                      onChange={handleChange(field?.name, field?.type)}
                      error={Boolean(errors[field.name])}
                      // helperText={errors[field.name] || ""}
                      helperText={
                        <Typography
                          variant="body2"
                          color="#D34040"
                          sx={{ marginLeft: "-0.8rem" }}
                        >
                          {errors[field.name] || ""}
                        </Typography>
                      }
                      inputProps={
                        field.type === "date"
                          ? { max: new Date().toISOString().split("T")[0] }
                          : {}
                      }
                    />
                  ) : field.type === "location" ? (
                    <>
                      {travelMode === "Road" && (
                        <GoogleMapsAutocomplete
                          title={field.label}
                          placeholder={field.placeholder}
                          value={formData?.[field.name]}
                          onPlaceSelect={(newValue) =>
                            handleLocationChange(field.name, newValue)
                          }
                          error={errors[field.name]}
                          type={[]}
                          titleDisabled={true}
                        />
                      )}

                      {travelMode === "Rail" && (
                        <GoogleMapsAutocompleteRail
                          title={field.label}
                          placeholder={field.placeholder}
                          value={formData?.[field.name]}
                          onPlaceSelect={(newValue) =>
                            handleLocationChangeRail(field.name, newValue)
                          }
                          error={errors[field.name]}
                          type={[]}
                          titleDisabled={true}
                          railMode={true}
                        />
                      )}

                      {travelMode === "Water" && (
                        <ShipAutocomplete
                          title={field.label}
                          value={formData?.[field.name]}
                          onChange={(newValue) =>
                            handleLocationChangeWater(field.name, newValue)
                          }
                          placeholder={field.placeholder}
                          error={errors[field.name]}
                          titleDisabled={true}
                        />
                      )}

                      {travelMode === "Air" && (
                        <AirportAutocomplete
                          title={field.label}
                          value={formData?.[field.name]}
                          onChange={(newValue) =>
                            handleLocationChangeAir(field.name, newValue)
                          }
                          placeholder={field.placeholder}
                          error={errors[field.name]}
                          titleDisabled={true}
                        />
                      )}

                      {errors?.[field.name] && (
                        <Typography variant="body2" color="#D34040">
                          {errors?.[field.name]}
                        </Typography>
                      )}
                    </>
                  ) : field.type === "multiple" ? (
                    <>
                      {travelMode === "Road" && (
                        <GoogleMapsAutocomplete
                          title={field.label}
                          placeholder={field.placeholder}
                          value={newLocation || null}
                          onPlaceSelect={(newValue) =>
                            handleLayover("newLocation", newValue, "road")
                          }
                          type={[]}
                          titleDisabled={true}
                        />
                      )}
                      {travelMode === "Rail" && (
                        <GoogleMapsAutocompleteRail
                          title={field.label}
                          placeholder={field.placeholder}
                          value={newLocation || null}
                          onPlaceSelect={(newValue) =>
                            handleLayover("newLocation", newValue, "rail")
                          }
                          type={[]}
                          titleDisabled={true}
                          railMode={true}
                        />
                      )}

                      {travelMode === "Water" && (
                        <ShipAutocomplete
                          title={field.label}
                          value={newLocation ? newLocation : undefined}
                          placeholder={field.placeholder}
                          onChange={(newValue) =>
                            handleLayover("newLocation", newValue, "water")
                          }
                          titleDisabled={true}
                        />
                      )}

                      {travelMode === "Air" && (
                        <AirportAutocomplete
                          title={field.label}
                          value={newLocation || null}
                          onChange={(newValue) =>
                            handleLayover("newLocation", newValue, "air")
                          }
                          placeholder={field.placeholder}
                          error={errors[field.fieldName]}
                          titleDisabled={true}
                        />
                      )}

                      <p
                        onClick={handleAddLocation}
                        style={{
                          textDecoration: "underline",
                          color: "rgba(28, 72, 107, 1)",
                          fontSize: "16px",
                          cursor: "pointer",
                          textAlign: "right",
                          marginTop: "0.5rem",
                        }}
                      >
                        Add Stop
                      </p>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                          marginTop: 16,
                        }}
                      >
                        {formData?.travelLocations?.map((location, index) => (
                          <Chip
                            key={index}
                            label={location}
                            onDelete={() =>
                              handleDeleteLocation(location, index)
                            }
                          />
                        ))}
                      </div>

                      {errors[field.name] && (
                        <Typography color="error" variant="caption">
                          {errors[field.name]}
                        </Typography>
                      )}
                    </>
                  ) : field.type === "docs" ? (
                    <FileField
                      // title={"Upload Documents"}
                      title={formatTitleWithOptional(
                        "Upload Documents (optional)"
                      )}
                      name={field.name}
                      errors={errors[field.name]}
                      fileUrls={uploadedFiles}
                      progress={uploadProgress[field.name] || []}
                      {...{
                        setUploadedFiles,
                        setUploadProgress,
                        setErrors,
                      }}
                    />
                  ) : field.type === "dynamic" &&
                    formData.travelMode === "Air" ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      value={formData[field?.name] || "Tap to select"}
                      onChange={handleChange(field?.name)}
                      error={Boolean(errors[field.name])}
                      helperText={errors[field.name] || ""}
                    >
                      <MenuItem value="Tap to select" disabled>
                        {defaultValue || "Tap to select"}
                      </MenuItem>
                      {field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : field.type === "dynamic" &&
                    formData.travelMode === "Water" ? (
                    <TextField
                      size="small"
                      fullWidth
                      placeholder="Enter Distance (Km)"
                      value={formData[field?.name] || ""}
                      onChange={handleChange(field?.name)}
                      error={Boolean(errors[field.name])}
                      helperText={errors[field.name] || ""}
                    ></TextField>
                  ) : field.type === "dynamic" &&
                    formData.travelMode === "Road" ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      value={formData[field?.name] || "Tap to select"}
                      onChange={handleChange(field?.name)}
                      error={Boolean(errors[field.name])}
                      helperText={errors[field.name] || ""}
                    >
                      <MenuItem value="Tap to select" disabled>
                        {defaultValue || "Tap to select"}
                      </MenuItem>
                      {field.options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : null}
                </div>
              );
            })}
          </form>

          {/* <Button onClick={handleCancel} color="secondary" variant="outlined">
          Cancel
        </Button> */}
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ backgroundColor: "#1C486B", textTransform: "none" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
      {/* </Modal> */}
    </Drawer>
  );
};

export default Form;
